import React, { Fragment } from "react";
import { Container, Spinner, Row, Col} from "react-bootstrap";
import StudentWinners from "../components/landing/StudentWinners";

const About = () => { 


  return( 
    <Fragment>

      <div className="bg-light mx-0 my-0 p-5 rounded-lg">
        <h1>About Us</h1>
      </div> 

      <Container fluid className="p-5">
        <Row>
          <p className="lead" style={{color:'#153574'}}>MindAntix helps organizations and individuals supercharge their creativity and innovation.</p>
        </Row>

        <Row>
          <Col className="col-12 col-md-7">
          <p style={{color:'#c87137'}}>
               In a world driven by technology and AI, creativity is the <em> only sustainable advantage </em> for both individuals and organizations.
            </p>
            <p>
                Creativity is now the top most skill that employers look for, yet it's also a skill that is not systematically nurtured. 77% of CEOs report that they struggle to find employees with creativity and innovation skills. Our education system fares worse. Student creativity scores have been declining steadily over the last few decades. We aim to close that gap by helping students, professionals and organizations become more creative.
            </p>
            <p>
                We help organizations co-create sustainable innovation-focused cultures through assessments, training and intervention programs. In our K-12 offering, students learn creativity techniques through fun, simple, and practical activities and exercises, and educators are supported through our professional development programs.
            </p>

          </Col>
          <Col className="col-12 col-md-5">
            <img 
              src="images/site/CreativityFallingDesign.png" 
              width="80%"
              alt="Declining Creativity" 
              fluid="true" />
          </Col>
        </Row>

        <Row className="mt-5">
          <Col className="col-12">
            <h5 style={{color:'#153574'}}> Our Vision </h5>
            <p>
                Our vision is a workforce of the future that is equipped with the necessary skills -- including creativity, critical thinking, and problem solving -- to succeed in a rapidly-evolving, AI-dominated world. <strong> <em>Everyone</em> has the potential to become creators of the future. </strong>
            </p>

            <h5 style={{color:'#153574'}}> Corporate Program </h5>

            <p>
                Our programs are based on our signature <span style={{color:'#c87137'}}> InnovationFirst </span> methodology and cover all levels of innovation - from individual to organizational: </p>
                <ul>
                    <li> <strong> High Performance Culture Assessment:</strong> Our proprietary innovation-readiness assessment helps you uncover areas that are hampering innovation and high performance in your team or organization.</li>
                    <li> <strong> Hacking Creativity Trainings:</strong> In this training program, we cover the fundamentals of three interrelated areas - cognitive creativity skills, emotional intelligence and collaboration - that are at the core of an innovation-focused culture. </li>
                    <li> <strong> Culture Co-creation:</strong> With Culture Co-creation we help you craft your organization’s innovative culture through assessment and intervention. </li>
                </ul>

            <h5 style={{color:'#153574'}}> K-12 Program </h5>
            <p>
                With MindAntix, students and teachers participate in a shared experience as they explore novel problems and learn from each other’s ideas.
            </p>
            <p>
                Through our cognitive brainteasers, students learn specific thinking styles that are proven to build creative thinking and develop a growth mindset. These concepts are put into action through the project based learning modules that challenge students to apply newly-learned strategies in real world scenarios.
            </p>
            <p>
                <strong> We make teaching and learning simple, practical, and relevant for everyone in the classroom.</strong>
            </p>
            <p>
                MindAntix gives teachers the resources and support to make instruction relevant for students and give them the opportunity to not just “be creative,” but to truly create by engaging in problem-solving and innovation. Through a combination of collaborative projects and solo assignments, students develop their own unique ideas within the shared experience of a community.
            </p>
            <p>
                All assignments include simple, straightforward guidelines that give students the freedom to tackle challenges without navigating a complicated structure. The modules are easy for teachers to implement, making it realistic and practical to incorporate activities into classroom instruction.
            </p>
            <p>
                Teachers use our online portal to assign, track, and evaluate students’ submissions. While there are no wrong answers in creative thinking, our rubric helps teachers evaluate students’ understanding of particular thinking styles by using Guilford's four-part metric system to measure fluency, flexibility, originality, and elaboration.
            </p>
          </Col>
        </Row>

      </Container>

      <StudentWinners />
      

    </Fragment>
       
  );
};
  
  export default About;